import { useState, useEffect } from "react";
import { FaHouseChimney } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import { PiPhoneCallFill } from "react-icons/pi";


const TextImageBanner = ({ label, bgImage }) => {
  const navigate = useNavigate();
  const [currentIndex, setCurrentIndex] = useState(0);
  const images = Array.isArray(bgImage) ? bgImage : [bgImage];
  useEffect(() => {
    if (images.length <= 1) return;
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % images.length);
    }, 4000);
    return () => clearInterval(interval);
  }, [images.length]);

  return (
    <section className="relative w-full h-[290px] sm:h-[430px] overflow-hidden">
      {images.map((img, index) => (
        <div
          key={index}
          className={`absolute inset-0 bg-cover bg-center transition-opacity duration-1000 ${index === currentIndex ? "opacity-100" : "opacity-0"
            }`}
          style={{ backgroundImage: img.startsWith("url(") ? img : `url(${img})` }}
        ></div>
      ))}
      <div className="absolute inset-0 w-full bg-gradient-to-r from-primaryColor/40 via-transparent to-primaryColor/40"></div>
      {/* Text content */}
      <div className="absolute inset-0 h-full w-[85%] max-w-7xl mx-auto flex justify-start items-center">
        <article className="capitalize font-semibold flex lg:flex-row flex-col justify-between w-full gap-y-4 z-10">
          {/* <h1 className="md:text-5xl text-3xl font-bold familjen-font text-white capitalize">
            {label}
          </h1> */}
          <div className="bg-white w-fit rounded-md xl:p-4 p-3 xl:text-base text-sm flex gap-3 items-center">
            <h1
              className="flex gap-1 transition-all familjen-font duration-500 hover:text-primaryColor cursor-pointer items-center"
              onClick={() => navigate("/")}
            >
              <span className="bg-primaryColor block p-2 rounded-md text-white">
                <FaHouseChimney />
              </span>
              home
            </h1>
            <span>/</span>
            <h1 className="text-primaryColor cursor-pointer capitalize">{label}</h1>
          </div>
          <div className="bg-white w-fit rounded-md xl:p-4 p-3 xl:text-base text-sm flex gap-3 items-center">
            <span className="bg-primaryColor block p-2 rounded-md text-white">
              <PiPhoneCallFill />
            </span>
            <div>
              <h1
                className="text-red-600 familjen-font"
              >
                free home sample collection
              </h1>
              {/* <span>/</span> */}
              <h1 className="text-primaryColor capitalize"><a href="tel:+917077560648" className="">
                +91 7077560648
              </a> <span>/</span>
                <a href="tel:+91 7077560638">
                  +91 7077560638
                </a></h1>
            </div>
          </div>
        </article>
      </div>
    </section>
  );
};

export default TextImageBanner;
